// @flow
import React from "react";
import Sheltered from "../../../svg/facilities/is_sheltered.svg";
import "./shelteredIcon.scss";

const ShelteredIcon = () => <Sheltered className="c-sheltered-icon" />;

export default ShelteredIcon;
